"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _decorators = require("decorators");

var _class;

var Image = (_class =
/*#__PURE__*/
function (_Activity) {
  babelHelpers.inherits(Image, _Activity);

  function Image() {
    babelHelpers.classCallCheck(this, Image);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(Image).apply(this, arguments));
  }

  babelHelpers.createClass(Image, [{
    key: "setup",
    value: function setup(constraint) {
      var _this = this;

      this._constraint = constraint;
      this.addEventListener('setupGlobalResize', this._imageGlobalResize);
      this.addEventListener('startedActivity', this._imageStarted);
      this.addEventListener('timerExpired', function () {
        return _this.endActivity();
      });
      this.addEventListener('endedActivity', function () {
        return _this.activityComplete();
      });
      this.startActivity();

      if (this.readOnly) {
        this.activityComplete();
      }
    }
  }, {
    key: "_imageGlobalResize",
    value: function _imageGlobalResize(event) {
      var constraint = event.objectConstraint;
      this.$('.activity-body').toggleClass('container', constraint.mode == 'Column');
      this.$('.activity-body .media-object').toggleClass('col-xs-12', constraint.mode == 'Column');
    }
  }, {
    key: "_imageStarted",
    value: function _imageStarted(event) {
      this.showActivityTitle();
      this.setupGlobalResize('.activity-body .media-object img', this._constraint);

      if (!this.readOnly) {
        this.startTimer(event.activity.endTime ? new Date(event.activity.endTime).getTime() - new Date(event.activity.startTime).getTime() : 10000, true);
      }
    }
  }]);
  return Image;
}(_base.default), (babelHelpers.applyDecoratedDescriptor(_class.prototype, "_imageGlobalResize", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_imageGlobalResize"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "_imageStarted", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_imageStarted"), _class.prototype)), _class);
exports.default = Image;